import React, { useState } from "react";
import {
  updateContainerDiversion
} from "../../../services/TransporterDataService";

const ContainerDiversionTable = ({
  tableData = [],
  date,
  setDate,
  filteredUserAccessData,
  refreshContainerDiversion
}) => {
  /* =========================================================
     STATE
     ========================================================= */

  const [selectedRows, setSelectedRows] = useState([]);

  const [showDiversion, setShowDiversion] = useState(false);

  const [saving, setSaving] = useState(false);
  const [divertedRowKeys, setDivertedRowKeys] = useState(
  () => new Set()
);

const getRowKey = (row) =>
  `${row?.DataOf || ""}_${row?.DailyContainerPlanningId || ""}`;


  const [selectedFields, setSelectedFields] = useState({
   
    ContainerNumber: true,
    SealNumber: true,
    VehicleNumber: true,
    LRNumber: true,
    DriverNumber: true,
   
  });

  /* =========================================================
     FIELD DISPLAY NAMES
     ========================================================= */

  const fieldLabels = {

    ContainerNumber: "Container Number",
    SealNumber: "Seal Number",
    VehicleNumber: "Vehicle Number",
    LRNumber: "LR Number",
    DriverNumber: "Driver Number"

  };

  /* =========================================================
     COMMON VALUE FORMATTER
     ========================================================= */

  const displayValue = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "-";
    }

    return value;
  };

  /* =========================================================
     DATE FORMATTER
     ========================================================= */

  const formatDate = (value) => {
    if (!value) {
      return "-";
    }

    try {
      const dateValue = new Date(value);

      if (isNaN(dateValue.getTime())) {
        return value;
      }

      return dateValue.toLocaleDateString("en-GB");
    } catch (error) {
      return value;
    }
  };

  /* =========================================================
     GET CONTAINER NUMBER
     
     Container number can come from:
     1. Container_Number
     2. Transporter_Container_Number
     ========================================================= */

  const getContainerNumber = (row) => {
    return (
      row?.Container_Number ||
      row?.Transporter_Container_Number ||
      null
    );
  };

  /* =========================================================
     ROW SELECTION
     ========================================================= */

  const handleRowSelection = (row) => {
    const planningId = row?.DailyContainerPlanningId;

    if (!planningId) {
      return;
    }

    const alreadySelected = selectedRows.some(
      (item) =>
        item.DailyContainerPlanningId === planningId
    );

    /* ---------------------------------------------------------
       If already selected, remove it
       --------------------------------------------------------- */

    if (alreadySelected) {
      setSelectedRows((prev) =>
        prev.filter(
          (item) =>
            item.DailyContainerPlanningId !== planningId
        )
      );

      return;
    }

    /* ---------------------------------------------------------
       Maximum 2 records
       --------------------------------------------------------- */

    if (selectedRows.length >= 2) {
      alert("Please select only two records.");

      return;
    }

    setSelectedRows((prev) => [
      ...prev,
      row
    ]);
  };

  /* =========================================================
     CHECK WHETHER ROW IS SELECTED
     ========================================================= */

  const isRowSelected = (row) => {
    return selectedRows.some(
      (item) =>
        item.DailyContainerPlanningId ===
        row.DailyContainerPlanningId
    );
  };

  /* =========================================================
     OPEN DIVERSION POPUP
     ========================================================= */

  const handleOpenDiversion = () => {
    if (selectedRows.length !== 2) {
      alert("Please select exactly two records.");

      return;
    }

    setShowDiversion(true);
  };

  /* =========================================================
     FIELD CHECKBOX CHANGE
     ========================================================= */

  const handleFieldChange = (field) => {
    setSelectedFields((prev) => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  /* =========================================================
     BUILD API RECORD
     ========================================================= */

  const buildDiversionRecord = (record) => {
    return {
      planningId:
        record?.DailyContainerPlanningId || null,

      assignContainerId:
        record?.AssignContainerId || null,

      transporterDataId:
        record?.TransporterDataId || null,

      dataOf:
        record?.DataOf || null,
      carrier:
      record?.Carrier || null,
      transporter:
      record?.Transporter || null,

      bookingNumber:
        record?.Booking_Number || null,

      market:
        record?.Market || null,

      country:
        record?.Country || null,

      date:
        record?.Date || null,

      containerNumber:
        getContainerNumber(record),

      sealNumber:
        record?.Seal_No || null,

      vehicleNumber:
        record?.Vehicle_No || null,

      lrNumber:
        record?.FLEETX_LR_No || null,

      driverNumber:
        record?.Driver_No || null
    };
  };

  /* =========================================================
     CONFIRM DIVERSION
     ========================================================= */

  const handleConfirmDiversion = async () => {
    /* ---------------------------------------------------------
       Validate selected records
       --------------------------------------------------------- */

    if (selectedRows.length !== 2) {
      alert("Please select exactly two records.");

      return;
    }

    /* ---------------------------------------------------------
       FROM / TO
       
       First selected record = FROM
       Second selected record = TO
       --------------------------------------------------------- */

    const fromRecord = selectedRows[0];

    const toRecord = selectedRows[1];
    /* ---------------------------------------------------------
   Validate Carrier
   --------------------------------------------------------- */

const fromCarrier = String(
  fromRecord?.Carrier || ""
).trim().toLowerCase();

const toCarrier = String(
  toRecord?.Carrier || ""
).trim().toLowerCase();

if (
  !fromCarrier ||
  !toCarrier ||
  fromCarrier !== toCarrier
) {
  alert(
    "Carrier must be same for FROM and TO records."
  );
  return;
}


/* ---------------------------------------------------------
   Validate Transporter
   --------------------------------------------------------- */

const fromTransporter = String(
  fromRecord?.Transporter || ""
).trim().toLowerCase();

const toTransporter = String(
  toRecord?.Transporter || ""
).trim().toLowerCase();

if (
  !fromTransporter ||
  !toTransporter ||
  fromTransporter !== toTransporter
) {
  alert(
    "Transporter must be same for FROM and TO records."
  );
  return;
}

    /* ---------------------------------------------------------
       Get selected fields
       --------------------------------------------------------- */

    const fieldsToExchange = Object.keys(
      selectedFields
    ).filter(
      (field) => selectedFields[field]
    );

    if (fieldsToExchange.length === 0) {
      alert(
        "Please select at least one field to exchange."
      );

      return;
    }

    /* ---------------------------------------------------------
       Build request
       --------------------------------------------------------- */

    const request = {
      from: buildDiversionRecord(fromRecord),

      to: buildDiversionRecord(toRecord),

      fields: fieldsToExchange
    };

    console.log(
      "Container Diversion Request:",
      request
    );

    /* ---------------------------------------------------------
       API CALL
       --------------------------------------------------------- */

    try {
      setSaving(true);

      const response =
        await updateContainerDiversion(request);

      console.log(
        "Container Diversion Response:",
        response
      );

      /* -------------------------------------------------------
         SUCCESS
         ------------------------------------------------------- */

      if (
        response?.data?.StatusCode === 200
      ) {
        alert(
          response?.data?.Message ||
          "Container diversion completed successfully."
        );
        setDivertedRowKeys((prev) => {
        const updated = new Set(prev);
        updated.add(getRowKey(fromRecord));
        updated.add(getRowKey(toRecord));

      return updated;
      });
        /* Close popup */
        setShowDiversion(false);

        /* Clear selected rows */
        setSelectedRows([]);

        /* Refresh table */
        if (
          typeof refreshContainerDiversion ===
          "function"
        ) {
          await refreshContainerDiversion();
        }

        return;
      }

      /* -------------------------------------------------------
         API returned failure
         ------------------------------------------------------- */

      alert(
        response?.data?.Message ||
        "Container diversion failed."
      );
    } catch (error) {
      console.error(
        "Container diversion error:",
        error
      );

      const errorMessage =
        error?.response?.data?.Message ||
        error?.response?.data?.message ||
        "Container diversion failed.";

      alert(errorMessage);
    } finally {
      setSaving(false);
    }
  };

  /* =========================================================
     CLOSE POPUP
     ========================================================= */

  const handleCloseDiversion = () => {
    if (saving) {
      return;
    }

    setShowDiversion(false);
  };

  /* =========================================================
     GET SELECTED FIELD VALUE
     ========================================================= */

// Highlight fields selected for diversion
const isFieldDiverted = (field) =>
  showDiversion && selectedFields[field];

const getDivertedCellClass = (field, row) => {
  const selected = isRowSelected(row);
  const diverted = divertedRowKeys.has(getRowKey(row));

  return selected && isFieldDiverted(field)
    ? "container-diversion-highlight"
    : "";
};

// Get field value for Exchange Preview
const getFieldValue = (record, field) => {
  if (!record) {
    return "-";
  }



    switch (field) {
      case "BookingNumber":
        return displayValue(
          record.Booking_Number
        );

      case "Market":
        return displayValue(
          record.Market
        );

      case "Country":
        return displayValue(
          record.Country
        );

      case "Date":
        return formatDate(
          record.Date
        );

      case "ContainerNumber":
        return displayValue(
          getContainerNumber(record)
        );

      case "SealNumber":
        return displayValue(
          record.Seal_No
        );

      case "VehicleNumber":
        return displayValue(
          record.Vehicle_No
        );

      case "LRNumber":
        return displayValue(
          record.FLEETX_LR_No
        );

      case "DriverNumber":
        return displayValue(
          record.Driver_No
        );

      case "DataOf":
        return displayValue(
          record.DataOf
        );

      default:
        return "-";
    }
  };

  /* =========================================================
     RENDER
     ========================================================= */

  return (
    <div className="container-diversion-wrapper">

      {/* =====================================================
          TABLE HEADER
          ===================================================== */}

      <div
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <div>
          {/* <h5 className="mb-1">
            Container Diversion
          </h5> */}

          <small className="text-muted">
            Select two records to exchange selected fields.
          </small>
        </div>

        <div>
          <button
            type="button"
            className="btn btn-primary"
            disabled={
              selectedRows.length !== 2 ||
              saving
            }
            onClick={handleOpenDiversion}
          >
            Divert Container
          </button>
        </div>
      </div>

      {/* =====================================================
          SELECTION INFORMATION
          ===================================================== */}

      {selectedRows.length > 0 && (
        <div className="alert alert-info py-2">
          <strong>
            Selected:
          </strong>{" "}

          {selectedRows.length} / 2

          {selectedRows.length === 2 && (
            <>
              {" "}
              — First record is{" "}
              <strong>FROM</strong> and second
              record is <strong>TO</strong>.
            </>
          )}
        </div>
      )}

      {/* =====================================================
          TABLE
          ===================================================== */}

      <div className="table-responsive">

        <table className="table table-bordered table-hover">

          <thead className="thead-default">

            <tr>

              <th
                style={{
                  width: "70px",
                  textAlign: "center"
                }}
              >
                Select
              </th>

              <th>
                Booking Number
              </th>

              <th>
                Market
              </th>

              <th>
                Country
              </th>

              <th>
                Planned Date
              </th>

              <th>
                Container Number
              </th>

              <th>
                Seal Number
              </th>

              <th>
                Vehicle Number
              </th>

              <th>
                LR Number
              </th>

              <th>
                Driver Contact No.
              </th>

              <th>
                Part Type
              </th>

            </tr>

          </thead>

          <tbody>

            {tableData &&
            tableData.length > 0 ? (

             
tableData.map((row, index) => {
  const selected = isRowSelected(row);

  // Add this line
  const diverted = divertedRowKeys.has(getRowKey(row));

  const selectedIndex = selectedRows.findIndex(
    (item) =>
      item.DailyContainerPlanningId ===
      row.DailyContainerPlanningId
  );

  return (
    <tr
      key={getRowKey(row) || index}
      className={[
        selected ? "table-primary" : "",
        diverted ? "container-diversion-completed" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >


                      {/* SELECT */}
                      <td
                        style={{
                          textAlign: "center"
                        }}
                      >

                        <input
                          type="checkbox"
                          checked={selected}
                          onChange={() =>
                            handleRowSelection(row)
                          }
                        />

                        {selected && (
                          <div
                            style={{
                              fontSize: "11px",
                              marginTop: "3px"
                            }}
                          >
                            {selectedIndex === 0
                              ? "FROM"
                              : "TO"}
                          </div>
                        )}

                      </td>

                      {/* BOOKING NUMBER */}
                      <td>
                        {displayValue(
                          row.Booking_Number
                        )}
                      </td>

                      {/* MARKET */}
                      <td >
                        {displayValue(
                          row.Market
                        )}
                      </td>

                      {/* COUNTRY */}
                      <td>
                        {displayValue(
                          row.Country
                        )}
                      </td>

                      {/* DATE */}
                      <td>
                        {formatDate(
                          row.Date
                        )}
                      </td>

                      {/* CONTAINER NUMBER */}
                      <td>
                        {displayValue(
                          getContainerNumber(row)
                        )}
                      </td>

                      {/* SEAL NUMBER */}
                      <td>
                        {displayValue(
                          row.Seal_No
                        )}
                      </td>

                      {/* VEHICLE NUMBER */}
                      <td>
                        {displayValue(
                          row.Vehicle_No
                        )}
                      </td>

                      {/* LR NUMBER */}
                      <td>
                        {displayValue(
                          row.FLEETX_LR_No
                        )}
                      </td>

                      {/* DRIVER NUMBER */}
                      <td>
                        {displayValue(
                          row.Driver_No
                        )}
                      </td>

                      {/* DATA OF */}
                      <td>
                        {displayValue(
                          row.DataOf
                        )}
                      </td>

                    </tr>
                  );
                }
              )

            ) : (

              <tr>

                <td
                  colSpan="11"
                  className="text-center"
                >
                  No Container Diversion records
                  found.
                </td>

              </tr>

            )}

          </tbody>

        </table>

      </div>

      {/* =====================================================
          DIVERSION MODAL
          ===================================================== */}

      {showDiversion &&
        selectedRows.length === 2 && (

          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor:
                "rgba(0,0,0,0.5)"
            }}
            role="dialog"
          >

            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              role="document"
            >

              <div className="modal-content">

                {/* =================================================
                    MODAL HEADER
                    ================================================= */}

                <div className="modal-header">

                  <h5 className="modal-title">
                    Container Diversion
                  </h5>

                  <button
                    type="button"
                    className="close"
                    onClick={
                      handleCloseDiversion
                    }
                    disabled={saving}
                  >
                    <span>
                      &times;
                    </span>
                  </button>

                </div>

                {/* =================================================
                    MODAL BODY
                    ================================================= */}

                <div className="modal-body">

                  {/* FROM / TO */}

                  <div className="row mb-4">

                    {/* FROM */}

                    <div className="col-md-6">

                      <div className="card">

                        <div className="card-header">
                          <strong>
                            FROM
                          </strong>
                        </div>

                        <div className="card-body">

                          {/* <p>
                            <strong>
                              Planning ID:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[0]
                                ?.DailyContainerPlanningId
                            )}
                          </p> */}

                          <p>
                            <strong>
                              Booking Number:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[0]
                                ?.Booking_Number
                            )}
                          </p>

                          <p>
                            <strong>
                              Market:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[0]
                                ?.Market
                            )}
                          </p>

                          <p>
                            <strong>
                              Country:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[0]
                                ?.Country
                            )}
                          </p>

                          <p>
                            <strong>
                              Planned Date:
                            </strong>{" "}
                            {formatDate(
                              selectedRows[0]
                                ?.Date
                            )}
                          </p>

                          <p>
                            <strong>
                              Part Type:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[0]
                                ?.DataOf
                            )}
                          </p>
                          <p>
  <strong>Carrier:</strong>{" "}
  {displayValue(
    selectedRows[0]?.Carrier
  )}
</p>

<p>
  <strong>Transporter:</strong>{" "}
  {displayValue(
    selectedRows[0]?.Transporter
  )}
</p>

                        </div>

                      </div>

                    </div>

                    {/* TO */}

                    <div className="col-md-6">

                      <div className="card">

                        <div className="card-header">
                          <strong>
                            TO
                          </strong>
                        </div>

                        <div className="card-body">

                          {/* <p>
                            <strong>
                              Planning ID:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[1]
                                ?.DailyContainerPlanningId
                            )}
                          </p> */}

                          <p>
                            <strong>
                              Booking Number:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[1]
                                ?.Booking_Number
                            )}
                          </p>

                          <p>
                            <strong>
                              Market:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[1]
                                ?.Market
                            )}
                          </p>

                          <p>
                            <strong>
                              Country:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[1]
                                ?.Country
                            )}
                          </p>

                          <p>
                            <strong>
                              Planned Date:
                            </strong>{" "}
                            {formatDate(
                              selectedRows[1]
                                ?.Date
                            )}
                          </p>

                          <p>
                            <strong>
                              Part Type:
                            </strong>{" "}
                            {displayValue(
                              selectedRows[1]
                                ?.DataOf
                            )}
                          </p>
                          <p>
  <strong>Carrier:</strong>{" "}
  {displayValue(
    selectedRows[1]?.Carrier
  )}
</p>

<p>
  <strong>Transporter:</strong>{" "}
  {displayValue(
    selectedRows[1]?.Transporter
  )}
</p>

                        </div>

                      </div>

                    </div>

                  </div>

                  {/* =================================================
                      FIELD SELECTION
                      ================================================= */}

                  <div className="card">

                    <div className="card-header">

                      <strong>
                        Select Fields to Exchange
                      </strong>

                    </div>

                    <div className="card-body">

                      <div className="row">

                        {Object.keys(
                          selectedFields
                        ).map((field) => (

                          <div
                            className="col-md-6 mb-3"
                            key={field}
                          >

                            <label
                              style={{
                                cursor: "pointer"
                              }}
                            >

                              <input
                                type="checkbox"
                                className="mr-2"
                                checked={
                                  selectedFields[
                                    field
                                  ]
                                }
                                onChange={() =>
                                  handleFieldChange(
                                    field
                                  )
                                }
                                disabled={saving}
                              />

                              {
                                fieldLabels[
                                  field
                                ]
                              }

                            </label>

                          </div>

                        ))}

                      </div>

                    </div>

                  </div>

                  {/* =================================================
                      EXCHANGE PREVIEW
                      ================================================= */}

                  <div className="card mt-3">

                    <div className="card-header">

                      <strong>
                        Exchange Preview
                      </strong>

                    </div>

                    <div className="card-body">

                      <div className="table-responsive">

                        <table className="table table-bordered">

                          <thead>

                            <tr>

                              <th>
                                Field
                              </th>

                              <th>
                                FROM
                              </th>

                              <th>
                                TO
                              </th>

                            </tr>

                          </thead>

                          <tbody>

                            {Object.keys(
                              selectedFields
                            )
                              .filter(
                                (field) =>
                                  selectedFields[
                                    field
                                  ]
                              )
                              .map(
                                (field) => (

                                  <tr
                                    key={field}
                                  >

                                    <td>
                                      <strong>
                                        {
                                          fieldLabels[
                                            field
                                          ]
                                        }
                                      </strong>
                                    </td>

                                  <td
  className={
    isFieldDiverted(field)
      ? "container-diversion-highlight"
      : ""
  }
>
  {getFieldValue(selectedRows[0], field)}
</td>

<td
  className={
    isFieldDiverted(field)
      ? "container-diversion-highlight"
      : ""
  }
>
  {getFieldValue(selectedRows[1], field)}
</td>

                                  </tr>

                                )
                              )}

                          </tbody>

                        </table>

                      </div>

                    </div>

                  </div>

                </div>

                {/* =================================================
                    MODAL FOOTER
                    ================================================= */}

                <div className="modal-footer">

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={
                      handleCloseDiversion
                    }
                    disabled={saving}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={
                      handleConfirmDiversion
                    }
                    disabled={
                      saving ||
                      Object.keys(
                        selectedFields
                      ).filter(
                        (field) =>
                          selectedFields[field]
                      ).length === 0
                    }
                  >

                    {saving
                      ? "Processing..."
                      : "Confirm Diversion"}

                  </button>

                </div>

              </div>

            </div>

          </div>

        )}

    </div>
  );
};

export default ContainerDiversionTable;